// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Careers_careers__Cqza0 {
  text-align: center;
  color: white;
}
.Careers_careers__Cqza0 img {
  width: 100%;
}
.Careers_careers__Cqza0 .Careers_title__UJni6 {
  text-align: center;
}
.Careers_careers__Cqza0 .Careers_title__UJni6 h1 {
  font-family: "hemi_head";
  font-style: italic;
  font-weight: 400;
  font-size: 40px;
  text-align: center;
  letter-spacing: 0.01em;
  padding-top: 50px;
  color: #FFFFFF;
  position: relative;
  display: inline-block;
  margin-bottom: 50px;
}
@media (max-width: 1200px) {
  .Careers_careers__Cqza0 .Careers_title__UJni6 h1 {
    padding-top: 0;
  }
}
.Careers_careers__Cqza0 .Careers_title__UJni6 h1:before {
  content: "";
  width: 80%;
  height: 1px;
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #ED1C24;
}
.Careers_careers__Cqza0 .Careers_title__UJni6 p {
  color: #ffffff;
  font-weight: 400;
  font-size: 16px;
  max-width: 700px;
  margin: 0px auto 40px auto;
}

.Careers_itemBox__z4i4F {
  width: 90%;
  margin: auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.Careers_careersItem__TshzI {
  width: 35%;
  margin-right: 50px;
  margin-bottom: 50px;
}
@media (max-width: 1100px) {
  .Careers_careersItem__TshzI {
    width: 50%;
    margin-right: 30px;
    margin-bottom: 30px;
  }
}
@media (max-width: 900px) {
  .Careers_careersItem__TshzI {
    width: 100%;
    margin-right: 0;
  }
}
.Careers_careersItem__TshzI .Careers_mainInfo__GLA-5 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin: auto;
  background: rgba(217, 217, 217, 0.06);
  box-shadow: 8px 7px 20px rgba(145, 145, 145, 0.25);
  border-radius: 26px;
  padding: 20px;
}
.Careers_careersItem__TshzI .Careers_mainInfo__GLA-5 div h2 {
  font-size: 20px;
  color: #EDEDED;
  font-family: hemi_head;
}
@media (max-width: 700px) {
  .Careers_careersItem__TshzI .Careers_mainInfo__GLA-5 div h2 {
    font-size: 23px;
  }
}
.Careers_careersItem__TshzI .Careers_mainInfo__GLA-5 div p {
  color: #EDEDED;
  font-family: Roboto;
  height: 150px;
  overflow: auto;
}
@media (max-width: 700px) {
  .Careers_careersItem__TshzI .Careers_mainInfo__GLA-5 div p {
    text-align: left;
    font-size: 15px;
    height: auto;
    overflow: hidden;
  }
}
.Careers_careersItem__TshzI .Careers_custom_file_input__8o7M8 {
  color: #FFFFFF;
}
.Careers_careersItem__TshzI .Careers_custom_file_input__8o7M8::-webkit-file-upload-button {
  visibility: visible;
  background: -webkit-linear-gradient(top, #f9f9f9, #e3e3e3);
  text-shadow: 1px 1px #fff;
  font-weight: 700;
  font-size: 10pt;
  border: 1px solid #999;
  border-radius: 3px;
  padding: 5px 8px;
  outline: none;
  white-space: nowrap;
  cursor: pointer;
}
.Careers_careersItem__TshzI .Careers_custom_file_input__8o7M8:hover {
  border-color: black;
}
.Careers_careersItem__TshzI .Careers_labell__zVF6T {
  color: #FFFFFF;
  font-size: 14px;
}
.Careers_careersItem__TshzI .Careers_file_box__GpKbI {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
}
.Careers_careersItem__TshzI button {
  width: 100px;
  height: 35px;
  background: #020202;
  border-radius: 5px;
  filter: drop-shadow(3px 3px 4px rgba(255, 255, 255, 0.25));
  font-weight: 400;
  font-size: 18px;
  letter-spacing: 0.01em;
  color: #FFFFFF;
  text-shadow: 3px 1px 4px rgba(255, 255, 255, 0.25), 3px 1px 4px rgba(255, 255, 255, 0.25);
  font-family: "hemi_head";
  cursor: pointer;
  margin-top: 20px;
}`, "",{"version":3,"sources":["webpack://./src/Pages/Careers/Careers.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,YAAA;AACF;AAAE;EACE,WAAA;AAEJ;AAAE;EACE,kBAAA;AAEJ;AADI;EACE,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,qBAAA;EACA,mBAAA;AAGN;AAFM;EAZF;IAaG,cAAA;EAKL;AACF;AAJM;EACE,WAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;EACA,2BAAA;EACA,yBAAA;AAMR;AAHI;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;AAKN;;AADA;EACE,UAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;AAIF;;AAFA;EACE,UAAA;EACA,kBAAA;EACA,mBAAA;AAKF;AAJE;EAJF;IAKI,UAAA;IACA,kBAAA;IACA,mBAAA;EAOF;AACF;AANE;EATF;IAUI,WAAA;IACA,eAAA;EASF;AACF;AARE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,qCAAA;EACA,kDAAA;EACA,mBAAA;EACA,aAAA;AAUJ;AARM;EACE,eAAA;EACA,cAAA;EACA,sBAAA;AAUR;AATQ;EAJF;IAKI,eAAA;EAYR;AACF;AAVM;EACE,cAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;AAYR;AAXQ;EALF;IAMI,gBAAA;IACA,eAAA;IACA,YAAA;IACA,gBAAA;EAcR;AACF;AAVE;EACE,cAAA;AAYJ;AAVE;EACE,mBAAA;EACA,0DAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AAYJ;AAVE;EACE,mBAAA;AAYJ;AAVE;EACE,cAAA;EAEA,eAAA;AAWJ;AATE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;AAWJ;AATE;EACE,YAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,0DAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,cAAA;EACA,yFAAA;EACA,wBAAA;EACA,eAAA;EACA,gBAAA;AAWJ","sourcesContent":[".careers{\n  text-align: center;\n  color: white;\n  img{\n    width: 100%;\n  }\n  .title {\n    text-align: center;\n    h1 {\n      font-family: \"hemi_head\";\n      font-style: italic;\n      font-weight: 400;\n      font-size: 40px;\n      text-align: center;\n      letter-spacing: 0.01em;\n      padding-top: 50px;\n      color: #FFFFFF;\n      position: relative;\n      display: inline-block;\n      margin-bottom: 50px;\n      @media (max-width: 1200px) {\n       padding-top: 0;\n      }\n      &:before {\n        content: \"\";\n        width: 80%;\n        height: 1px;\n        position: absolute;\n        bottom: -10px;\n        left: 50%;\n        transform: translateX(-50%);\n        background-color: #ED1C24;\n      }\n    }\n    p{\n      color: #ffffff;\n      font-weight: 400;\n      font-size: 16px;\n      max-width: 700px;\n      margin: 0px auto 40px auto;\n    }\n  }\n}\n.itemBox{\n  width: 90%;\n  margin: auto;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n.careersItem{\n  width: 35%;\n  margin-right: 50px;\n  margin-bottom: 50px;\n  @media (max-width: 1100px) {\n    width: 50%;\n    margin-right: 30px;\n    margin-bottom: 30px;\n  }\n  @media (max-width: 900px) {\n    width: 100%;\n    margin-right: 0;\n  }\n  .mainInfo{\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    margin: auto;\n    background: rgba(217, 217, 217, 0.06);\n    box-shadow: 8px 7px 20px rgba(145, 145, 145, 0.25);\n    border-radius: 26px;\n    padding: 20px;\n    div{\n      h2{\n        font-size: 20px;\n        color: #EDEDED;\n        font-family: hemi_head;\n        @media (max-width: 700px) {\n          font-size: 23px;\n        }\n      }\n      p{\n        color: #EDEDED;\n        font-family: Roboto;\n        height: 150px;\n        overflow: auto;\n        @media (max-width: 700px) {\n          text-align: left;\n          font-size: 15px;\n          height: auto;\n          overflow: hidden;\n        }\n      }\n    }\n  }\n  .custom_file_input{\n    color: #FFFFFF;\n  }\n  .custom_file_input::-webkit-file-upload-button {\n    visibility: visible;\n    background:  -webkit-linear-gradient(top, #f9f9f9, #e3e3e3);\n    text-shadow: 1px 1px #fff;\n    font-weight: 700;\n    font-size: 10pt;\n    border: 1px solid #999;\n    border-radius: 3px;\n    padding: 5px 8px;\n    outline: none;\n    white-space: nowrap;\n    cursor: pointer;\n  }\n  .custom_file_input:hover{\n    border-color: black;\n  }\n  .labell{\n    color: #FFFFFF;\n    //width: 100px;\n    font-size: 14px;\n  }\n  .file_box{\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    text-align: left;\n  }\n  button {\n    width: 100px;\n    height: 35px;\n    background: #020202;\n    border-radius: 5px;\n    filter: drop-shadow(3px 3px 4px rgba(255, 255, 255, 0.25));\n    font-weight: 400;\n    font-size: 18px;\n    letter-spacing: 0.01em;\n    color: #FFFFFF;\n    text-shadow: 3px 1px 4px rgba(255, 255, 255, 0.25), 3px 1px 4px rgba(255, 255, 255, 0.25);\n    font-family: \"hemi_head\";\n    cursor: pointer;\n    margin-top: 20px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"careers": `Careers_careers__Cqza0`,
	"title": `Careers_title__UJni6`,
	"itemBox": `Careers_itemBox__z4i4F`,
	"careersItem": `Careers_careersItem__TshzI`,
	"mainInfo": `Careers_mainInfo__GLA-5`,
	"custom_file_input": `Careers_custom_file_input__8o7M8`,
	"labell": `Careers_labell__zVF6T`,
	"file_box": `Careers_file_box__GpKbI`
};
export default ___CSS_LOADER_EXPORT___;
